import {difference, intersection} from 'lodash'
import {isUndef} from '@/utils/common'

export enum conditionE {
  include = 1,
  exclusive,
  is,
  isNot,
  prefix,
  suffix,
  isNull,
  isNotNull,
  inScope,
  equal,
  unequal,
  greater,
  less,
  greaterThan,
  lessThan,
  notInScope,
  before,
  past
}
/* 1	包含	include
2	不包含	exclusive
3	是	is
4	不是	isNot
5	开头为	prefix
6	结尾为	suffix
7	为空	isNull
8	不为空	isNotNull
9	在范围内 inScope
10	等于	equal
11	不等于	unequal
12	大于	greater
13	小于	less
14	大于等于	greaterThan
15	小于等于	lessThan
16	不在范围内	notInScope
17	早于 before
18	晚于	past */
let loop = () => void 0
let strInclude = (filterValue, value) => value && filterValue.some(item => value.includes(item));
let strExclusive = (filterValue, value) => !value || !filterValue.some(item => value.includes(item));
let is = (filterValue, value) => {
  return filterValue === value
}
// 级联包含
let cascadeInclude = (filterValue = [], value) => {
  return filterValue.every((item, index) => {
    return item && item === value[index]
  })
}
let cascadeExclusive = (filterValue, value) => {
  return !cascadeInclude(filterValue, value)
}
let isNot = (filterValue, value) => filterValue !== value
let prefix = (filterValue, value)  => value && value.startsWith(filterValue)
let suffix = (filterValue, value)  => value && value.endsWith(filterValue)
let isNull = (filterValue, value)  => {  
  if (value instanceof Array) {
    return value.length === 0
  } else {
    return !value
  }
}
let isNotNull = (filterValue, value)  => {
  if (value instanceof Array) {
    return value.length !== 0
  } else {
    return value
  }
}
let inScope = (max, min, value) => value && (value >= min && value <= max)
let notInScope = (max, min, value) => value && (value < min || value > max)
let less = (filterValue, value) => value && (value < filterValue)
let greater = (filterValue, value) => value && (value > filterValue)
let greaterThan = (filterValue, value) => value && (value >= filterValue)
let lessThan = (filterValue, value) => value && (value <= filterValue)
let scopedType = ['inScope', 'notInScope']
let includeType = ['include', 'exclusive']
let commonCondition = {
  include:  strInclude,
  exclusive: strExclusive,
  is,
  isNot,
  prefix,
  suffix,
  isNull,
  isNotNull,
  inScope,
  notInScope,
  equal: is,
  unequal: isNot,
  greater,
  less,
  greaterThan,
  lessThan,
  before: less,
  past: greater

}
let cascadeConditon = {
  include:  cascadeInclude,
  exclusive: cascadeExclusive,
}
/* 数组条件判断 */
let arrInclude = (filterValue, value) => intersection(filterValue, value).length && value.length !== 0
let arrExclusive = (filterValue, value) => {
  return intersection(filterValue, value).length === 0 || value.length === 0
}
let arrIs = (filterValue, value)  => difference(filterValue, value).length === 0 && difference(value, filterValue).length === 0
let arrNot = (filterValue, value)  => {
  return difference(filterValue, value).length !== 0 || difference(value, filterValue).length !== 0
}
let multiConditon = {
  include:  arrInclude,
  exclusive: arrExclusive,
  is: arrIs,
  isNot: arrNot,
  isNull,
  isNotNull,
}
function split(data, type = ',') {
  return data.split(type)
}
export function conditionProcess (condition, value) {
  // 筛选类型
  let type = conditionE[condition.filterType]
  if (condition.fieldType === 'checkbox') {
    // 多选的情况
    let fn = multiConditon[type] || loop
    let filterValue = condition.filterValue ? split(condition.filterValue) : []
    return fn(filterValue, (value || []).map(item => item.toString()))
  } else if (condition.fieldType === 'region' || condition.fieldType === 'cascadeSelect') {
    let fn = (includeType.includes(type) ? cascadeConditon[type] : multiConditon[type]) || loop
    return fn(condition.filterValue || [], value || [])
  } else if (condition.fieldType === 'department' || condition.fieldType === 'member' ) {
    // 部门，成员
    let fn = multiConditon[type] || loop
    let filterValue = condition.filterValue ? split(condition.filterValue) : []
    value = value ? split(value) : []
    return fn(filterValue, value)
  } else {
    let fn = commonCondition[type] || loop
    if (scopedType.includes(type)) {
      // 在范围内，不在范围内
      return fn(condition.maxFilterValue, condition.minFilterValue, value)
    } else if (includeType.includes(type)) {
      // 包含。不包含
      // text类型的分隔符为$^$
      let splitType = condition.fieldType === 'text' ? '&^&' : ','
      let filterValue = condition.filterValue ? split(condition.filterValue, splitType) : []
      return fn(filterValue, (value || '').toString())
    } else if (condition.fieldType === 'number') {
      let filterValue = condition.filterValue
      return fn(filterValue, value ? Number(value) : value)
    } else {
      let filterValue = condition.filterValue
      return fn(filterValue, (value || '').toString())
    }
  }
}
export function conditonFn (conditions: any[] = [], form) {
  for (const one of conditions) {
    if (isUndef(form[one.businessId])) {
      // 为空，不为空判断
      let type = conditionE[one.filterType]
      if (type === 'isNotNull' || type === 'isNull') {
        
        let fn = commonCondition[type]
        return fn(null, null)
      }
    }
    if (!conditionProcess(one, form[one.businessId])) {
      return false
    }
  }
  return true
}

export function conditonJudgment (conditionArr = [], form) {
  if (!conditionArr.length) {
    return true
  }
  return conditionArr.some(conditions => {
    return conditonFn(conditions, form)
  })
}
